import React from "react";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const CustomDateTime = ({
  label,
  value,
  onChange,
  required = false,
  error = false,
  helperText = "",
  format = "YYYY-MM-DD HH:mm",
  disabledAfter = null,
  name,
  ...props
}) => {
  return (
    <div className="mb-3">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          label={label}
          value={value ? dayjs(value, format) : null}
          onChange={(newValue) => {
            onChange({
              target: {
                name,
                value: newValue ? newValue.format(format) : "",
              },
            });
          }}
          format={format}
          slotProps={{
            textField: {
              required,
              error,
              helperText,
              fullWidth: true,
              size: "small",
              sx: { minWidth: 200, borderRadius: 1 },
              InputLabelProps: { shrink: true },
              inputProps: {
                max: disabledAfter || undefined,
              },
              ...props,
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default CustomDateTime;